import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

function SidebarItem({ name, icon, path, selected }) {
  const { i18n } = useTranslation();
  const navigate = useNavigate();

  return (
    <ListItem sx={{ p: '0px !important' }}>
      <ListItemButton
        selected={selected}
        onClick={() => navigate(`/${i18n.language}/${path}`)}
      >
        <ListItemIcon>
          <FontAwesomeIcon icon={icon} />
        </ListItemIcon>
        <ListItemText primary={name} />
      </ListItemButton>
    </ListItem>
  );
}

export default SidebarItem;
